import React,{useState,useEffect,lazy} from 'react';
import axios from 'axios'
import {  Slider,Statistic,Tabs,Modal } from 'antd';
import { ArrowUpOutlined,MinusCircleFilled,ToolOutlined,DollarCircleFilled, ArrowDownOutlined,FileFilled,WalletFilled,SearchOutlined,FundViewOutlined,
   UserOutlined, AccountBookOutlined,CalculatorFilled,CloseOutlined,SwapOutlined,MailFilled,GroupOutlined,AccountBookFilled, DollarCircleOutlined,EditFilled,MessageFilled,DollarOutlined,CarFilled,LoadingOutlined,PlusCircleFilled,CloudSyncOutlined,FileSearchOutlined,WarningOutlined,LinkOutlined } from '@ant-design/icons';
import moment from 'moment';
import { Line,Pie,Bar } from 'react-chartjs-2';
import {withGetScreen} from 'react-getscreen'
import { Tooltip,Popover,Table,Popconfirm,Input, Button,Collapse,Card,Avatar,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin,Badge,Alert } from 'antd';
import {
  Col,
  Row,
} from 'reactstrap';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import * as serverconfig from '../serverconn'
import * as serversocketconfig from '../serversocketconfig'
import { MdShoppingCart } from 'react-icons/md';

import CurrencyFormat from 'react-currency-format';
import Highlighter from 'react-highlight-words';
import Websocket from 'react-websocket';
import { Link } from 'react-router-dom';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { NavLink } from 'react-router-dom'
import  MemberForm from '../components/MemberForm'
import  LoanCalculator from '../components/LoanCalculator'
import  LoanSecurityTransferView from './LoanSecurityTransferView'
import * as primarycolor from '../primarycolor'
import {
  fetchUnbalancedJournalsFyAlert,
  fetchTransactionsMissingJournalsFyAlert,
} from '../systemHealthAlerts'

var CryptoJS = require("crypto-js");

const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;


const style = { background: '#0092ff', padding: '8px 0',borderRadius: '7px',justifyContent:'center', alignItems:'center',display: 'flex', };
const dateFormat = 'DD/MM/YYYY';
const yeardateFormat = 'YYYY';
const monthdateFormat = 'MM/YYYY';

const { Meta } = Card;
const { Panel } = Collapse;
const { TabPane } = Tabs;
const FormItem=Form.Item;
const { Option } = Select;

var bizuserid= ''
var sacco= ''
var token= ''


//target sticky note
const TargetStickyNote = ({ title, description, onClose,date_one,date_two }) => {
  return (
    <Card style={{ width: 300, margin: 10 }}
    extra={<Button onClick={onClose} style={{ color: 'red' }} icon={<CloseOutlined />}>Close</Button>}

    >
      <p><strong>Target:</strong> {title}</p>
      <p><strong>Description:</strong> {description}</p>
      <p><strong>Duration:</strong> {date_one} - {date_two}</p>

    </Card>
  );
}


class QuickMenu extends React.Component {

  state = {
    currentmonth:moment().format(monthdateFormat).toString(),
    companyprofile:{},
    datarequested:true,
    totalmemberaccounts:0,
    totalfemaleaccounts:0,
    totalmaleaccounts:0,
    totalloansthismonth:0,
    totalmembersavings:0,
    memberformvisible:false,
    transactformvisible:false,
    calculatorformvisible:false,
    members:[],
    loansformvisible:false,
    monthlyloanissuances:0,
    monthlyloanapplications:0,
    monthlyloanassessments:0,
    monthlyloanapprovals:0,
    dashboardlocked:false,
    utilitiesmodalvisible:false,
    userprofile:{},
    userrights:{},
    reservetranfermodalvisible:false,
    user_targets:[],
    unbalancedJournalCount:0,
    missingJournalCount:0,
    journalHealthPeriod:'',
    journalHealthLoading:false,

  };


  callback =(key) =>{
    console.log(key);
    console.log(this.state.yearlymonthlysales)
  }

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("bizuserid")){
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
   }else{
      bizuserid= ''
   }
    
    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


   let form_data = new FormData();
   form_data.append('userid', bizuserid);
   
   //get the user profile here
   axios.post(serverconfig.backendserverurl+'/customqueries/get_user_profile',form_data,{
     headers: {
       'content-type': 'multipart/form-data'
     }
     })
   .then(res => {
       this.setState({
         userprofile:res.data
       })
    
   })


    axios.get(serverconfig.backendserverurl+`/api/saccos/${sacco}`)
    .then(res => {
        this.setState({
          companyprofile:res.data
        })

        if (res.data.activated===false){
          this.setState({dashboardlocked:true})
        }

    })

   

    axios.get(serverconfig.backendserverurl+`/api/accountrights/?user=${bizuserid}`)
    .then(res => {
        this.setState({
          userrights:res.data[0]
        })

        this.setState({datarequested:false})
    })



    //get targets
    let form_data_1_1_1_1 = new FormData();
    form_data_1_1_1_1.append('sacco', sacco);
    form_data_1_1_1_1.append('user_id', Number(bizuserid));

    //Now send the post resquest
      axios.post(serverconfig.backendserverurl+'/customqueries/get_userperiodic_targets', form_data_1_1_1_1, {
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
    .then(res => {
      this.setState({user_targets:JSON.parse(res.data.report)})

    })
    .catch(error => console.log(error)) 


   
  }



getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ?(
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};

//close member form
closeMemberForm=()=>{
  this.setState({memberformvisible:false})
}

openMemberForm=()=>{
  this.setState({memberformvisible:true})
}

// close/open transact form
closeTransactForm=()=>{
  this.setState({transactformvisible:false})
}

openTransactForm=()=>{
  this.setState({transactformvisible:true})
}

// close/open transact form
closeCalculatorForm=()=>{
  this.setState({calculatorformvisible:false})
}

openCalculatorForm=()=>{
  this.setState({calculatorformvisible:true})
}

//close open loan options modal
closeloanoptionsForm=()=>{
  this.setState({loansformvisible:false})
}

openloanoptionsForm=()=>{
  this.setState({loansformvisible:true})
}

//open close utilities modal
openutilitiesmodal=()=>{
  this.setState({utilitiesmodalvisible:true})
  this.loadJournalHealthCounts()
}

closeutilitiesmodal=()=>{
  this.setState({utilitiesmodalvisible:false})
}

loadJournalHealthCounts=()=>{
  if (!sacco) {
    return
  }

  const isBranchManager = this.state.userprofile && this.state.userprofile.branch_manager === true
  this.setState({journalHealthLoading:true})

  const requests = [
    isBranchManager ? fetchUnbalancedJournalsFyAlert(sacco, 5) : Promise.resolve({ data: {} }),
    fetchTransactionsMissingJournalsFyAlert(sacco, 5),
  ]

  Promise.all(requests)
    .then(([unbalancedRes, missingRes]) => {
      const unbalancedData = unbalancedRes.data || {}
      const missingData = missingRes.data || {}
      this.setState({
        unbalancedJournalCount: unbalancedData.has_unbalanced ? unbalancedData.count : 0,
        missingJournalCount: missingData.has_missing_journals ? missingData.count : 0,
        journalHealthPeriod:
          unbalancedData.dateone && unbalancedData.datetwo
            ? `${unbalancedData.dateone} to ${unbalancedData.datetwo}`
            : '',
        journalHealthLoading:false,
      })
    })
    .catch(() => {
      this.setState({journalHealthLoading:false})
    })
}

renderUtilityCard=(to, icon, label, subtitle=null, badgeCount=null)=>{
  const card = (
    <Card
      hoverable
      style={{
        minHeight: 170,
        width: '100%',
        borderRadius: 10,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      }}
      bodyStyle={{
        padding: '22px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <NavLink to={to} style={{ color: 'inherit', textDecoration: 'none', width: '100%' }} onClick={this.closeutilitiesmodal}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 120,
            textAlign: 'center',
          }}
        >
          {icon}
          <p
            style={{
              marginTop: 14,
              marginBottom: subtitle ? 6 : 0,
              fontWeight: 700,
              color: '#154360',
              fontSize: 14,
              lineHeight: 1.45,
              letterSpacing: 0.2,
            }}
          >
            {label}
          </p>
          {subtitle ? (
            <span style={{ fontSize: 12, color: '#667085', lineHeight: 1.4, maxWidth: 220 }}>
              {subtitle}
            </span>
          ) : null}
        </div>
      </NavLink>
    </Card>
  )

  return (
    <Col xs="12" sm="6" md="6" lg="4" style={{ marginBottom: 16, padding: '0 10px' }}>
      {badgeCount > 0 ? (
        <Badge count={badgeCount} overflowCount={999} offset={[-8, 8]}>
          {card}
        </Badge>
      ) : card}
    </Col>
  )
}






  render() {


if(this.state.dashboardlocked===true){
  return(
    <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
    <h3 style={{fontWeight:'bolder',color:'red'}}>NOTE: Your dashboard is currently locked. Contact system adminstrators.Your Licence may be expired or some thing else. Thanks</h3>
    </div>
  )
}else{

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
            <Spin size="large">
              <div className="content">
                <h3>Pisacco</h3>
              </div>
            </Spin>        
        </div>
      )
  
    }else{

      
        return(
          <div className="animated fadeIn">  
          <h3 style={{fontStyle:'oblique',fontWeight:'bolder'}}>{this.state.companyprofile.sacco_name} QUICK MENU</h3>
    
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {this.state.user_targets.map((target, index) => (
              <TargetStickyNote
                key={index}
                title={target.title}
                description={target.description}
                date_one={target.date_one}
                date_two={target.date_two}
                onClose={
                  () => {
                    this.setState({user_targets:this.state.user_targets.filter(tgt => tgt.id !== target.id)})
                  }
                }

              />
            ))}
          </div>
          <br></br>


           <Row>
            <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>
            <Tooltip title="Click to Deposit/Withdraw Money" placement="top">
            <Card
                  onClick={()=>{this.openTransactForm()}}
                  hoverable
                  style={{ 
                    background:"white",
                    display: 'flex',
                    justifyContent:'center',
                    padding:4,
                    alignItems:'center' }}
                >
    
                    <div style={{width:'100%',
                      padding:10,
                      alignItems:'center',
                      alignSelf:'center',
                      display:'flex',
                      justifyContent:'center',
                      flexDirection:'column'
                      }}>
                  <DollarOutlined style={{color:primarycolor.primarycolor,fontSize: '50px'}}/>
                  <h4 style={{fontWeight:'bold'}}>TRANSACT</h4>
                      </div>
                </Card>
              </Tooltip>
             
            </Col>
            
            <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>
            <Tooltip title="Click to Add New Member" placement="top">
              <Card
                  onClick={()=>{this.openMemberForm()}}
                  hoverable
                  style={{ 
                    background:"white",
                    display: 'flex',
                    justifyContent:'center',
                    padding:4,
                    alignSelf:'center',
                    alignItems:'center' }}
                >
    
                    <div style={{width:'100%',
                      padding:10,
                      alignItems:'center',
                      alignSelf:'center',
                      display:'flex',
                      justifyContent:'center',
                      flexDirection:'column'
                      }}>
                      <PlusCircleFilled style={{color:primarycolor.primarycolor,fontSize: '50px'}}/>
                      <h4 style={{fontWeight:'bold'}}>NEW MEMBER</h4>
                     </div>   
    
                </Card>
                </Tooltip>
              </Col>
    
              <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>
              <Tooltip title="Click to Add Loan Application or Make Loan Repayment" placement="top">
              <Card
                  onClick={()=>{this.openloanoptionsForm()}}
                  hoverable
                  style={{ 
                    background:"white",
                    display: 'flex',
                    justifyContent:'center',
                    padding:4,
                    alignSelf:'center',
                    alignItems:'center' }}
                >
                  <div style={{width:'100%',
                      padding:10,
                      alignItems:'center',
                      alignSelf:'center',
                      display:'flex',
                      justifyContent:'center',
                      flexDirection:'column'
                      }}>
                        <PlusCircleFilled style={{color:primarycolor.primarycolor,fontSize: '50px'}}/>
                        <h4 style={{fontWeight:'bold'}}>LOAN ACTIONS</h4>
                      </div>
                    
                </Card>
              </Tooltip>
    
             
              </Col>
    
              <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>
              <Tooltip title="Click to open utilities" placement="top">
              <Card
                  onClick={()=>{this.openutilitiesmodal()}}
                  hoverable
                  style={{ 
                    background:"white",
                    display: 'flex',
                    justifyContent:'center',
                    padding:4,
                    alignItems:'center' }}
                >
                  <div style={{width:'100%',
                      padding:10,
                      alignItems:'center',
                      alignSelf:'center',
                      display:'flex',
                      justifyContent:'center',
                      flexDirection:'column'
                      }}>
                        <ToolOutlined style={{color:primarycolor.primarycolor,fontSize: '50px'}}/>
                        <h4 style={{fontWeight:'bold'}}>UTILITIES</h4>
                      </div>               
    
                </Card>
    
              </Tooltip>
    
            
              </Col>
            
            </Row>
    
    
    
          
    
    

               
          
            {
            this.state.userrights.can_register_members?
    
            <Modal              
            visible={this.state.memberformvisible}
            title="Member Creation"
            onCancel={this.closeMemberForm}
    
            footer={[
              <Button key="back" onClick={this.closeMemberForm}>
                Cancel
              </Button>
              ]}
              >
              <MemberForm />
                
            </Modal>  
            :
            null
            }
    
    
    
    
            {/* TRANSACT MODAL*/}
    
            <Modal    
                       
              visible={this.state.transactformvisible}
              title="Account Transaction"
              onCancel={this.closeTransactForm}
          
              footer={[
                <Button key="back" onClick={this.closeTransactForm}>
                  Cancel
                </Button>
                ]}
                width={1000}
                >
    
    <Row>
             
          {
            this.state.userrights.can_deposit?
            <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>

            <Card
            hoverable
            style={{ 
              padding:3,
              alignItems:'center',
              alignSelf:'center',
              display:'flex',
              justifyContent:'center',
              marginRight:6,
              flexDirection:'column'}}
          > 
          <NavLink to='/deposit/'>
          <div                  
           style={{ 
              padding:3,
              alignItems:'center',
              alignSelf:'center',
              display:'flex',
              justifyContent:'center',
              flexDirection:'column' }}>
              <PlusCircleFilled style={{color:'#154030',fontSize: '50px',alignSelf:'center'}}/>
              <h6 style={{fontWeight:'bolder',color:'#154360'}}>DEPOSIT </h6>
          </div>
          </NavLink>
    
          </Card> 
          </Col>
     
            :
            null
            }
    
    
           {
            this.state.userrights.can_withdraw?
            <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>

            <Card
              hoverable
              style={{ 
                padding:3,
                alignItems:'center',
                alignSelf:'center',
                display:'flex',
                justifyContent:'center',
                flexDirection:'column' }}
            > 
            <NavLink to='/withdraw/'>
            <div                  
            style={{ 
                padding:3,
                alignItems:'center',
                alignSelf:'center',
                display:'flex',
                justifyContent:'center',
                flexDirection:'column' }}>
            <MinusCircleFilled style={{color:'#154360',fontSize: '50px',alignSelf:'center'}}/>
            <h6 style={{fontWeight:'bolder',color:'#15430'}}>WITHDRAW </h6>
    
            </div>
    
            </NavLink>
    
          </Card> 
     
     </Col>
            :
            null
            }


          {
            this.state.userprofile.branch_manager?
            <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>

            <Card
              hoverable
              style={{ 
                padding:3,
                alignItems:'center',
                alignSelf:'center',
                display:'flex',
                justifyContent:'center',
                flexDirection:'column' }}
            > 
            <NavLink to='/multijournal/'>
            <div                  
            style={{ 
                padding:3,
                alignItems:'center',
                alignSelf:'center',
                display:'flex',
                justifyContent:'center',
                flexDirection:'column' }}>
            <PlusCircleFilled style={{color:'#154360',fontSize: '50px',alignSelf:'center'}}/>
            <h6 style={{fontWeight:'bolder',color:'#15430'}}>MULTI JOURNAL (Expenses/Incomes/Opening balances etc)</h6>
    
            </div>
    
            </NavLink>
    
          </Card> 
          </Col>
     
            :
            null
            }

        {
            this.state.userprofile.branch_manager?
            <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>
            <Card
              hoverable
              style={{
                padding:3,
                alignItems:'center',
                alignSelf:'center',
                display:'flex',
                justifyContent:'center',
                flexDirection:'column' }}
            >
            <NavLink to='/member_payments/'>
            <div
            style={{
                padding:3,
                alignItems:'center',
                alignSelf:'center',
                display:'flex',
                justifyContent:'center',
                flexDirection:'column' }}>
            <PlusCircleFilled style={{color:'#154360',fontSize: '50px',alignSelf:'center'}}/>
            <h6 style={{fontWeight:'bolder',color:'#15430'}}>Member payments</h6>
            </div>
            </NavLink>
          </Card>
          </Col>
            :
            null
            }

    
                 {
                  this.state.userprofile.branch_manager?
                  this.state.companyprofile.sharesfeature?
                  <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>

                  <Card
                  hoverable
                  style={{ 
                    padding:3,
                    alignItems:'center',
                    alignSelf:'center',
                    display:'flex',
                    justifyContent:'center',
                    marginRight:6,
                    flexDirection:'column'}}
                > 
                <NavLink to='/sharetransfer/'>
                <div                  
                 style={{ 
                    padding:3,
                    alignItems:'center',
                    alignSelf:'center',
                    display:'flex',
                    justifyContent:'center',
                    flexDirection:'column' }}>
                    <SwapOutlined style={{color:'#154030',fontSize: '30px',alignSelf:'center'}}/>
                    <h6 style={{fontWeight:'bolder',color:'#154360'}}>SHARE TRANSFER </h6>
                </div>
                </NavLink>
    
                </Card> 
                </Col>
                  :
                  null
                  
                  :
                  null
                }


              {
                  this.state.userprofile.branch_manager?
                  <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>

                  <Card
                  hoverable
                  style={{ 
                    padding:3,
                    alignItems:'center',
                    alignSelf:'center',
                    display:'flex',
                    justifyContent:'center',
                    marginRight:6,
                    flexDirection:'column'}}
                > 
                <NavLink to='/inter_account_tranfer_betweenmembers/'>
                <div                  
                 style={{ 
                    padding:3,
                    alignItems:'center',
                    alignSelf:'center',
                    display:'flex',
                    justifyContent:'center',
                    flexDirection:'column' }}>
                    <SwapOutlined style={{color:'#154030',fontSize: '30px',alignSelf:'center'}}/>
                    <h6 style={{fontWeight:'bolder',color:'#154360'}}>INTERMEMBER - SAVINGS TRANSFER </h6>
                </div>
                </NavLink>
    
                </Card> 
                </Col>
                 
                  :
                  null
                }


                {
    
                  this.state.companyprofile.showsubaccounttransfer && this.state.userrights.can_withdraw?
                  <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>

                      <Card
                      hoverable
                      style={{ 
                        padding:3,
                        alignItems:'center',
                        alignSelf:'center',
                        display:'flex',
                        justifyContent:'center',
                        flexDirection:'column' }}
                    > 
                    <NavLink to='/loansecuritytransfer/'>
                    <div                  
                    style={{ 
                        padding:3,
                        alignItems:'center',
                        alignSelf:'center',
                        display:'flex',
                        justifyContent:'center',
                        flexDirection:'column' }}>
                    <SwapOutlined style={{color:'#154360',fontSize: '30px',alignSelf:'center'}}/>
                    <h6 style={{fontWeight:'bolder',color:'#15430'}}>LOAN SECURITY TRANSFERS </h6>

                    </div>
                    </NavLink>

                  </Card>
                  </Col> 
                  :
                  null
                }


    
                  {
    
                    this.state.companyprofile.showsubaccounttransfer?
                     this.state.userrights.can_withdraw?
                     <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>

                        <Card
                        hoverable
                        style={{ 
                          padding:3,
                          alignItems:'center',
                          alignSelf:'center',
                          display:'flex',
                          justifyContent:'center',
                          flexDirection:'column' }}
                      > 
                      <NavLink to='/subaccounttransfer/'>
                      <div                  
                      style={{ 
                          padding:3,
                          alignItems:'center',
                          alignSelf:'center',
                          display:'flex',
                          justifyContent:'center',
                          flexDirection:'column' }}>
                      <SwapOutlined style={{color:'#154360',fontSize: '30px',alignSelf:'center'}}/>
                      <h6 style={{fontWeight:'bolder',color:'#15430'}}>SUB ACCOUNT TRANSFERS </h6>
      
                      </div>
      
                      </NavLink>
      
                    </Card> 
                    </Col>
                     :
                     null
                     
                    :
                    null
                  }


                  {
                      
                      this.state.userrights.can_withdraw?
                      <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>

                          <Card
                          hoverable
                          style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            flexDirection:'column' }}
                        > 
                        <NavLink to='/interaccounttransfer/'>
                        <div                  
                        style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            flexDirection:'column' }}>
                        <SwapOutlined style={{color:'#154360',fontSize: '30px',alignSelf:'center'}}/>
                        <h6 style={{fontWeight:'bolder',color:'#15430'}}>SUB ACCOUNTS TRANSFERS </h6>

                        </div>
                        </NavLink>

                      </Card> 
                      </Col>
                                           
                      :
                      null
                    }
                

              {
                      
                      this.state.userrights.can_withdraw?
                      <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>

                          <Card
                          hoverable
                          style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            marginRight:6,
                            flexDirection:'column'}}
                        > 
                        <NavLink to='/savingsinterestpayoff/'>
                        <div                  
                        style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            flexDirection:'column' }}>
                        <SwapOutlined style={{color:'#154360',fontSize: '30px',alignSelf:'center'}}/>
                        <h6 style={{fontWeight:'bolder',color:'#15430'}}>SAVINGS INTEREST TRANSFER </h6>

                        </div>
                        </NavLink>

                      </Card> 
                      </Col>
                                           
                      :
                      null
                    }


                    {
                          this.state.userrights.can_deposit && this.state.userprofile.branch_manager?
                          <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>

                          <Card
                          hoverable
                          style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            marginRight:6,
                            flexDirection:'column'}}
                        > 
                        <NavLink to='/dividendscalculator/'>
                        <div                  
                        style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            flexDirection:'column' }}>
                            <PlusCircleFilled style={{color:'#154030',fontSize: '50px',alignSelf:'center'}}/>
                            <h6 style={{fontWeight:'bolder',color:'#154360'}}>DIVIDENDS AWARD </h6>
                        </div>
                        </NavLink>
                  
                        </Card> 
                        </Col>
                          :
                          null}



                  {
                          this.state.userrights.can_deposit && this.state.userprofile.branch_manager?
                          <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>

                          <Card
                          hoverable
                          style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            marginRight:6,
                            flexDirection:'column'}}
                        > 
                        <NavLink to='/dataonboarding/'>
                        <div                  
                        style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            flexDirection:'column' }}>
                            <PlusCircleFilled style={{color:'#154030',fontSize: '50px',alignSelf:'center'}}/>
                            <h6 style={{fontWeight:'bolder',color:'#154360'}}>DATA UPLOADS </h6>
                        </div>
                        </NavLink>
                  
                        </Card> 
                        </Col>
                          :
                          null}


                      {
                          this.state.userrights.can_deposit && this.state.userprofile.branch_manager?
                        
                          <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>
                          <Card
                          hoverable
                          style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            marginRight:6,
                            flexDirection:'column'}}
                        > 
                        <NavLink to='/mobilemoneycollections/'>
                        <div                  
                        style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            flexDirection:'column' }}>
                            <PlusCircleFilled style={{color:'#154030',fontSize: '50px',alignSelf:'center'}}/>
                            <h6 style={{fontWeight:'bolder',color:'#154360'}}>MOBILE MONEY  </h6>
                        </div>
                        </NavLink>
                  
                        </Card> 
                        </Col>
                          :
                          null}



                        {
                           this.state.userprofile.branch_manager?
                        
                          <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>
                          <Card
                          hoverable
                          style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            marginRight:6,
                            flexDirection:'column'}}
                        > 
                        <NavLink to='/quicktransact/'>
                        <div                  
                        style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            flexDirection:'column' }}>
                            <PlusCircleFilled style={{color:'#154030',fontSize: '50px',alignSelf:'center'}}/>
                            <h6 style={{fontWeight:'bolder',color:'#154360'}}> QUICK TRANSACT </h6>
                        </div>
                        </NavLink>
                  
                        </Card> 
                        </Col>
                          :
                          null}


                        {
                           this.state.userprofile.branch_manager?
                        
                          <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>
                          <Card
                          hoverable
                          style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            marginRight:6,
                            flexDirection:'column'}}
                        > 
                        <NavLink to='/cumulativedividends_tosavings/'>
                        <div                  
                        style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            flexDirection:'column' }}>
                            <SwapOutlined style={{color:'#154030',fontSize: '50px',alignSelf:'center'}}/>
                            <h6 style={{fontWeight:'bolder',color:'#154360'}}> CUMULATIVE DIVIDENDS TO SAVINGS TRANSFER </h6>
                        </div>
                        </NavLink>
                  
                        </Card> 
                        </Col>
                          :
                          null
                          }



                          {
                           this.state.userprofile.branch_manager?
                        
                          <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>
                          <Card
                          hoverable
                          style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            marginRight:6,
                            flexDirection:'column'}}
                        > 
                        <NavLink to='/vouchers_list/'>
                        <div                  
                        style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            flexDirection:'column' }}>
                            <PlusCircleFilled style={{color:'#154030',fontSize: '50px',alignSelf:'center'}}/>
                            <h6 style={{fontWeight:'bolder',color:'#154360'}}> PAYMENT VOUCHERS </h6>
                        </div>
                        </NavLink>
                  
                        </Card> 
                        </Col>
                          :
                          null
                          }



                      {
                           this.state.userprofile.branch_manager && this.state.userrights.can_settargetsforothers?
                        
                          <Col xs="12" sm="6" lg="3" style={{padding: '5px'}}>
                          <Card
                          hoverable
                          style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            marginRight:6,
                            flexDirection:'column'}}
                        > 
                        <NavLink to='/user_targets/'>
                        <div                  
                        style={{ 
                            padding:3,
                            alignItems:'center',
                            alignSelf:'center',
                            display:'flex',
                            justifyContent:'center',
                            flexDirection:'column' }}>
                            <PlusCircleFilled style={{color:'#154030',fontSize: '50px',alignSelf:'center'}}/>
                            <h6 style={{fontWeight:'bolder',color:'#154360'}}> USER TARGETS </h6>
                        </div>
                        </NavLink>
                  
                        </Card> 
                        </Col>
                        :
                        null
                        }





              </Row>
                
            </Modal> 
    
    
            {/* lOAN CALCULATOR MODAL*/}
             <Modal              
              visible={this.state.calculatorformvisible}
              title="Loan Calculator"
              onCancel={this.closeCalculatorForm}
              style={{width:1000}}
              footer={[
                <Button key="back" onClick={this.closeCalculatorForm}>
                  Cancel
                </Button>
                ]}
                >
                <LoanCalculator />
                  
            </Modal>    
    
            {/* LOAN OPTIONS MODAL*/}
    
            <Modal    
                       
              visible={this.state.loansformvisible}
              title="Loan Actions"
              onCancel={this.closeloanoptionsForm}
          
              footer={[
                <Button key="back" onClick={this.closeloanoptionsForm}>
                  Cancel
                </Button>
                ]}
                >
    
    
    
              <div style={{display:'flex',alignContent:'center',justifyContent:'center',flexDirection:'row'}} >
    
                {
                  this.state.userrights.can_register_loans?
                  <Card
                  hoverable
                  style={{ 
                    padding:3,
                    alignItems:'center',
                    alignSelf:'center',
                    display:'flex',
                    justifyContent:'center',
                    marginRight:6,
                    flexDirection:'column'}}
                > 
                <NavLink to='/loanapplication/'>
                <div                  
                 style={{ 
                    padding:3,
                    alignItems:'center',
                    alignSelf:'center',
                    display:'flex',
                    justifyContent:'center',
                    flexDirection:'column' }}>
                    <PlusCircleFilled style={{color:'#154030',fontSize: '50px',alignSelf:'center'}}/>
                    <p style={{fontWeight:'bolder',color:'#154360'}}>LOAN APPLICATION </p>
                </div>
                </NavLink>
    
                </Card>
                  :
                  null
                }
    
    
            
                {
                  this.state.userrights.can_enter_loan_repayment?
                  <Card
                  hoverable
                  style={{ 
                    padding:3,
                    alignItems:'center',
                    alignSelf:'center',
                    display:'flex',
                    justifyContent:'center',
                    flexDirection:'column' }}
                > 
                <NavLink to='/loanrepaymentdirect/'>
                <div                  
                 style={{ 
                    padding:3,
                    alignItems:'center',
                    alignSelf:'center',
                    display:'flex',
                    justifyContent:'center',
                    flexDirection:'column' }}>
                <PlusCircleFilled style={{color:'#154360',fontSize: '50px',alignSelf:'center'}}/>
                <p style={{fontWeight:'bolder',color:'#154360'}}>LOAN REPAYMENT (SAVINGS TRANSFER) </p>
    
                </div>
    
                </NavLink>
               </Card> 
                  :
                  null
                }   

              </div>
              <br></br>
              <div style={{display:'flex',alignContent:'center',justifyContent:'center',flexDirection:'row'}} >
    
              {
                 this.state.userprofile.branch_manager?
                    <Card
                    hoverable
                    style={{ 
                      padding:3,
                      alignItems:'center',
                      alignSelf:'center',
                      display:'flex',
                      justifyContent:'center',
                      marginRight:6,
                      flexDirection:'column'}}
                  > 
                  <NavLink to='/loan_consolidation/'>
                  <div                  
                  style={{ 
                      padding:3,
                      alignItems:'center',
                      alignSelf:'center',
                      display:'flex',
                      justifyContent:'center',
                      flexDirection:'column' }}>
                      <PlusCircleFilled style={{color:'#154030',fontSize: '50px',alignSelf:'center'}}/>
                      <h6 style={{fontWeight:'bolder',color:'#154360'}}> LOAN CONSOLIDATION </h6>
                  </div>
                  </NavLink>
            
                  </Card> 
                  :
                  null
                  }
             

              </div>



            </Modal> 
    
    
            {/**Utilities modal */}
            <Modal
              visible={this.state.utilitiesmodalvisible}
              title={<span style={{ fontSize: 18, fontWeight: 700 }}>Utilities</span>}
              width={1050}
              style={{ top: 32 }}
              bodyStyle={{ padding: '28px 24px 12px', minHeight: 360 }}
              onCancel={this.closeutilitiesmodal}
              footer={[
                <Button key="back" onClick={this.closeutilitiesmodal}>
                  Close
                </Button>
              ]}
            >
              {this.state.userprofile.branch_manager === true ? (
                <>
                  <Alert
                    type="info"
                    showIcon
                    style={{ marginBottom: 20 }}
                    message="Journal integrity (current financial year)"
                    description={
                      this.state.journalHealthLoading
                        ? 'Checking journal health…'
                        : this.state.journalHealthPeriod
                          ? `Period: ${this.state.journalHealthPeriod}. Open a tool below to review issues flagged at login or run a custom date range.`
                          : 'Find unbalanced journals and member transactions missing GL entries. Counts refresh each time you open Utilities.'
                    }
                  />
                  <Typography.Title level={5} style={{ marginBottom: 4, color: '#154360' }}>
                    Journal integrity
                  </Typography.Title>
                  <Typography.Paragraph type="secondary" style={{ marginBottom: 12 }}>
                    Fix posting mistakes before period-end close. Badge counts reflect the current FY window from your data entry cap.
                  </Typography.Paragraph>
                  <Row style={{ margin: '0 -10px' }}>
                    {this.renderUtilityCard(
                      '/unbalanced_journal_numbers/',
                      <WarningOutlined style={{ color: '#cf1322', fontSize: 56 }} />,
                      'UNBALANCED JOURNALS',
                      'Debits ≠ credits on the same journal number',
                      this.state.unbalancedJournalCount
                    )}
                    {this.renderUtilityCard(
                      '/transactions_missing_journals/',
                      <FileSearchOutlined style={{ color: '#d48806', fontSize: 56 }} />,
                      'MISSING GL JOURNALS',
                      'Member subaccount txns with no GeneralJournal lines',
                      this.state.missingJournalCount
                    )}
                    {this.renderUtilityCard(
                      '/unmatched_journal_chart_report/',
                      <LinkOutlined style={{ color: '#096dd9', fontSize: 56 }} />,
                      'JOURNAL CHART LINK',
                      'Link legacy journal account text to chart of accounts'
                    )}
                  </Row>
                  <Divider />
                </>
              ) : null}

              <Typography.Title level={5} style={{ marginBottom: 12, color: '#154360' }}>
                General utilities
              </Typography.Title>
              <Row style={{ margin: '0 -10px' }}>
                {this.state.userrights.sendmessages
                  ? this.renderUtilityCard(
                      '/messaging/',
                      <MessageFilled style={{ color: '#154030', fontSize: 56 }} />,
                      'SMS MESSAGING',
                      'Send bulk or individual SMS to members'
                    )
                  : null}

                {this.renderUtilityCard(
                  '/loancalculator/',
                  <CalculatorFilled style={{ color: '#154030', fontSize: 56 }} />,
                  'LOAN CALCULATOR',
                  'Estimate installments and interest schedules'
                )}

                {this.state.userprofile.branch_manager === true
                  ? this.renderUtilityCard(
                      '/salaryrequisition/',
                      <DollarCircleFilled style={{ color: '#154030', fontSize: 56 }} />,
                      'SALARY REQUISITION',
                      'Prepare and submit salary payment requests'
                    )
                  : null}

                {this.state.userprofile.branch_manager === true
                  ? this.renderUtilityCard(
                      '/batchemail_statementsending/',
                      <MailFilled style={{ color: '#154030', fontSize: 56 }} />,
                      'BATCH EMAIL STATEMENTS',
                      'Email member statements for a date range'
                    )
                  : null}
              </Row>
            </Modal>

            <Modal    
              visible={this.state.reservetranfermodalvisible}
              title="Loan Security Transfer Form"
              onCancel={()=>{this.setState({reservetranfermodalvisible:false})}}
              footer={[
                <Button key="back" onClick={()=>{this.setState({reservetranfermodalvisible:false})}}>
                  Cancel
                </Button>
                ]}
                >
                <LoanSecurityTransferView />

            </Modal>

          </div>
        )

    }
  
  }

  }
}

export default QuickMenu; 
